
import { Mapper } from "../../../../base/utils/mapper";
import { MembersPhysiotherapyModel } from "../../../../domain/models/consult/members-physiotherapy.model";
import { MembersPhysiotherapyEntity } from "../entities/members-physiotherapy.entity";
export class MembersPhysiotherapyImplementationRepositoryMapper extends Mapper<MembersPhysiotherapyEntity, MembersPhysiotherapyModel>{
            mapFrom(param:  MembersPhysiotherapyEntity):  MembersPhysiotherapyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  MembersPhysiotherapyModel):  MembersPhysiotherapyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }